/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SwapScreenerLeadResidents200ResponseDataLead1 } from './SwapScreenerLeadResidents200ResponseDataLead1';
import {
    SwapScreenerLeadResidents200ResponseDataLead1FromJSON,
    SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped,
    SwapScreenerLeadResidents200ResponseDataLead1ToJSON,
} from './SwapScreenerLeadResidents200ResponseDataLead1';

/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200ResponseData
 */
export interface SwapScreenerLeadResidents200ResponseData {
    /**
     * 
     * @type {SwapScreenerLeadResidents200ResponseDataLead1}
     * @memberof SwapScreenerLeadResidents200ResponseData
     */
    lead_1: SwapScreenerLeadResidents200ResponseDataLead1;
    /**
     * 
     * @type {SwapScreenerLeadResidents200ResponseDataLead1}
     * @memberof SwapScreenerLeadResidents200ResponseData
     */
    lead_2: SwapScreenerLeadResidents200ResponseDataLead1;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200ResponseData interface.
 */
export function instanceOfSwapScreenerLeadResidents200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_1" in value;
    isInstance = isInstance && "lead_2" in value;

    return isInstance;
}

export function SwapScreenerLeadResidents200ResponseDataFromJSON(json: any): SwapScreenerLeadResidents200ResponseData {
    return SwapScreenerLeadResidents200ResponseDataFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_1': SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json['lead_1']),
        'lead_2': SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json['lead_2']),
    };
}

export function SwapScreenerLeadResidents200ResponseDataToJSON(value?: SwapScreenerLeadResidents200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_1': SwapScreenerLeadResidents200ResponseDataLead1ToJSON(value.lead_1),
        'lead_2': SwapScreenerLeadResidents200ResponseDataLead1ToJSON(value.lead_2),
    };
}

